var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92934 7.912H11.5753L10.0633 15.5H7.41734L8.92934 7.912ZM10.6233 7.072C10.166 7.072 9.79734 6.946 9.51734 6.694C9.23734 6.442 9.09734 6.12933 9.09734 5.756C9.09734 5.31733 9.25134 4.958 9.55934 4.678C9.87667 4.38867 10.292 4.244 10.8053 4.244C11.272 4.244 11.6453 4.36533 11.9253 4.608C12.2053 4.84133 12.3453 5.14467 12.3453 5.518C12.3453 5.97533 12.1867 6.34867 11.8693 6.638C11.552 6.92733 11.1367 7.072 10.6233 7.072Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsInfo);
export default __webpack_public_path__ + "static/media/icons-info.a229c786d5c624a4bf1b1d68db161173.svg";
export { ForwardRef as ReactComponent };